import React from "react";

const AboutValuesSection = () => {
  return (
    <section className="section section-soft about-values-section">
      <div className="container">
        <div className="split-grid reverse-on-mobile">
          <div>
            <p className="eyebrow">Our Values</p>
            <h2>Clear work, honest guidance, and measurable momentum.</h2>
            <p>
              Our values shape how we support candidates every week: focused
              execution, transparent updates, human judgment, and smarter
              systems that keep improving.
            </p>
            <div className="check-grid">
              <span>Results Over Activity</span>
              <span>Transparency Always</span>
              <span>Human-First Mindset</span>
              <span>Innovation Every Day</span>
            </div>
          </div>
          <div
            className="section-image about-values-image"
            aria-label="Team discussing candidate outcomes and values"
          ></div>
        </div>
      </div>
    </section>
  );
};

export default AboutValuesSection;
